/** Alineado con `apps/api/.../storage-upload.constants.ts` (validación cliente). */
export const DASHBOARD_STORAGE_ALLOWED_MIME_VAULT = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "application/pdf",
] as const;

export const DASHBOARD_STORAGE_ALLOWED_MIME_IMAGES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
] as const;

export const DASHBOARD_STORAGE_MAX_SIZE_LABEL = "5MB";

/**
 * FilePond `FileExtensionValidator` solo interpreta extensiones con punto desde `accept` HTML;
 * `image/*` no aporta ninguna, y con `image/*,.pdf` solo quedaba `.pdf` → rechazaba imágenes.
 */
export const DASHBOARD_STORAGE_ALLOWED_EXTENSIONS_VAULT = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
  ".pdf",
] as const;

export const DASHBOARD_STORAGE_ALLOWED_EXTENSIONS_IMAGES = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".gif",
] as const;
